document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('evento-fields');
  const selectTipoEvento = document.getElementById('evento_tipo_evento');
  const notaFiscalSelector = document.getElementById('nota_fiscal_selector');
  const compraSelector = document.getElementById('compra_selector');

  if (!container || !selectTipoEvento) return;

  const initialDataPrevisao = container.dataset.initialDataPrevisao || "";
  const initialIndicadorQuitacao = container.dataset.initialIndicadorQuitacao || "1";
  const initialIndicadorAceitacao = container.dataset.initialIndicadorAceitacao || "";
  const initialEventoId = container.dataset.initialEventoId || "";

  function getDataPrevisaoEntregaHtml(dataValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_data_previsao_entrega_attributes_data_previsao_entrega">
              Data Prevista de Entrega *
            </label>            
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </span>
              <input type="text" 
                name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][data_previsao_entrega]" 
                id="evento_data_previsao_entrega_attributes_data_previsao_entrega" 
                class="form-control" 
                placeholder="dd/mm/aaaa" 
                required 
                value="${dataValue}">
            </div>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getPagamentoIntegralHtml(indicadorValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra que houve pagamento integral efetivo da operação, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC. 
            A informação é utilizada para liberar o crédito presumido do adquirente.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              Indicador de Quitação *
            </label>            
            <input type="hidden" 
                   name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][indicador_quitacao]" 
                   id="evento_pagamento_integral_attributes_indicador_quitacao"
                   value="${indicadorValue}">
            <p class="form-control-static">
              <strong>1 - Quitação integral confirmada</strong>
              <br>
              <small class="text-muted">
                Este valor indica que o pagamento da operação foi realizado integralmente.
              </small>
            </p>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getAceiteDebitoApuracaoHtml(indicadorValue, eventoId) {
    const opcao0Selecionado = indicadorValue === "0" ? 'selected="selected"' : '';
    const opcao1Selecionado = indicadorValue === "1" ? 'selected="selected"' : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra o aceite ou não aceite dos valores de uma nota de crédito para fins de apuração de IBS/CBS, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_aceite_debito_apuracao_attributes_indicador_aceitacao">
              Indicador de Aceitação *
            </label>            
            <select name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][indicador_aceitacao]"
                    id="evento_aceite_debito_apuracao_attributes_indicador_aceitacao"
                    class="form-control"
                    required>
              <option value="">Selecione</option>
              <option value="0" ${opcao0Selecionado}>0 - Não aceite</option>
              <option value="1" ${opcao1Selecionado}>1 - Aceite</option>
            </select>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function updateDocumentSelectorVisibility(tipoEvento) {
    if (!notaFiscalSelector || !compraSelector) return;

    if (!tipoEvento) {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'none';
    } else if (tipoEvento === 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao') {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'block';
    } else {
      notaFiscalSelector.style.display = 'block';
      compraSelector.style.display = 'none';
    }
  }

  function renderEventoFields(tipoEvento) {
    if (!tipoEvento) {
      container.innerHTML = '<div class="alert alert-info">Selecione um tipo de evento para exibir os campos específicos.</div>';
      updateDocumentSelectorVisibility(tipoEvento);
      return;
    }

    switch(tipoEvento) {
      case 'Fiscal::NotaFiscal::Evento::DataPrevisaoEntrega':
        container.innerHTML = getDataPrevisaoEntregaHtml(initialDataPrevisao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::PagamentoIntegral':
        container.innerHTML = getPagamentoIntegralHtml(initialIndicadorQuitacao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao':
        container.innerHTML = getAceiteDebitoApuracaoHtml(initialIndicadorAceitacao, initialEventoId);
        break;
      default:
        container.innerHTML = '<div class="alert alert-info">Selecione um tipo de evento válido.</div>';
    }
    updateDocumentSelectorVisibility(tipoEvento);
  }

  selectTipoEvento.addEventListener('change', function() {
    renderEventoFields(this.value);
  });

  const tipoEventoInicial = selectTipoEvento.value;
  if (tipoEventoInicial) {
    renderEventoFields(tipoEventoInicial);
  }
});
